import script from "./legoTreeExtend.vue?vue&type=script&lang=js"
export * from "./legoTreeExtend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/components/lego/extend/legoTreeExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10c0b4e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10c0b4e0', __exports__)) {
    api.reload('10c0b4e0', __exports__)
  }
  
}


export default __exports__